import { OEMProfile } from "../../types/Profiles/oemProfile.types";

import CompanyTab from "./tabs/CompanyTab";
import IndustrialTab from "./tabs/IndustrialTab";
import ProcurementTab from "./tabs/ProcurementTab";
import ActivityTab from "./tabs/ActivityTab";
import { useTranslate } from "../../hooks/LanguageProvider";

interface Props {
  profile: OEMProfile;
  activeTab: string;
  setActiveTab: (tab: string) => void;
  onProfileUpdated?: () => Promise<void> | void;
}

export default function ProfileTabs({
  profile,
  activeTab,
  setActiveTab,
  onProfileUpdated,
}: Props) {
  const { translate } = useTranslate();

  return (
    <>
      <div className="card border-0 shadow-sm rounded-4 mb-4">
        <div className="card-body p-3">
          <ul className="nav nav-pills gap-2">
            <li className="nav-item">
              <button
                type="button"
                className={`nav-link rounded-3 ${activeTab === "company" ? "active" : ""
                  }`}
                onClick={() => setActiveTab("company")}
              >
                {translate("company")}
              </button>
            </li>

            <li className="nav-item">
              <button
                type="button"
                className={`nav-link rounded-3 ${activeTab === "industrial" ? "active" : ""
                  }`}
                onClick={() => setActiveTab("industrial")}
              >
                {translate("industrial")}
              </button>
            </li>

            <li className="nav-item">
              <button
                type="button"
                className={`nav-link rounded-3 ${activeTab === "procurement" ? "active" : ""
                  }`}
                onClick={() => setActiveTab("procurement")}
              >
                {translate("procurement")}
              </button>
            </li>

            <li className="nav-item">
              <button
                type="button"
                className={`nav-link rounded-3 ${activeTab === "activity" ? "active" : ""
                  }`}
                onClick={() => setActiveTab("activity")}
              >
                {translate("activity")}
              </button>
            </li>
          </ul>
        </div>
      </div>

      {activeTab === "company" && (
        <CompanyTab profile={profile} onProfileUpdated={onProfileUpdated} />
      )}
      {activeTab === "industrial" && (
        <IndustrialTab profile={profile} onProfileUpdated={onProfileUpdated} />
      )}
      {activeTab === "procurement" && (
        <ProcurementTab profile={profile} onProfileUpdated={onProfileUpdated} />
      )}
      {activeTab === "activity" && <ActivityTab profile={profile} />}
    </>
  );
}